import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageWrap from '../components/PageWrap';
import useDocumentMeta from '../hooks/useDocumentMeta';
import routeMetaFor from '../utils/routeMeta';
import { HOME, STUDIO, products } from '../data/siteContent';

// One card per approved catalogue entry. A product is only a link when it has
// an approved internal destination; nothing here links to a store or a date.
function ProductCard({ product, delay }) {
  const body = (
    <>
      <div className={`tag ${product.productPath ? 'tag-live' : 'tag-soon'}`} style={{ marginBottom: '14px' }}>
        {product.productPath && <i className="fas fa-circle" style={{ fontSize: '6px' }}></i>} {product.status}
      </div>
      <h3>{product.name}</h3>
      <p style={{ marginTop: '8px', fontSize: '0.9rem' }}>{product.description}</p>
      {product.productPath && (
        <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--accent)', fontSize: '0.85rem', fontWeight: 600 }}>
          Explore {product.name} <i className="fas fa-arrow-right"></i>
        </div>
      )}
    </>
  );

  if (!product.productPath) {
    return (
      <div className={`card reveal ${delay}`} data-testid={`product-card-${product.id}`}>{body}</div>
    );
  }

  return (
    <Link
      to={product.productPath}
      className={`card reveal ${delay}`}
      style={{ textDecoration: 'none', borderTop: '2px solid var(--accent)' }}
      data-testid={`product-card-${product.id}`}
    >
      {body}
    </Link>
  );
}

export default function Home() {
  useDocumentMeta(routeMetaFor('/'));
  return (
    <PageWrap testId="home-page">
      <Navbar />

      {/* ── HERO ─────────────────────────────────────────── */}
      <section style={{ position: 'relative', display: 'flex', alignItems: 'center', paddingTop: 'calc(var(--nav-h) + 72px)', paddingBottom: '72px', overflow: 'hidden' }}>
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="wrap" style={{ position: 'relative', zIndex: 1 }}>
          <div className="eyebrow coral reveal">{HOME.eyebrow}</div>
          <h1 className="reveal d1" style={{ marginBottom: '20px', lineHeight: '1.08', maxWidth: '900px' }}>
            {HOME.heading}
          </h1>
          <p className="lead reveal d2" style={{ marginBottom: '18px', maxWidth: '760px' }}>
            {STUDIO.primaryStatement}
          </p>
          <p className="reveal d2" style={{ marginBottom: '36px', maxWidth: '760px' }}>
            {STUDIO.supportingStatement}
          </p>
          <div className="btn-group reveal d3">
            <Link to={HOME.primaryCta.to} className="btn btn-primary btn-lg" data-testid="hero-apps-btn">{HOME.primaryCta.label}</Link>
            <Link to={HOME.secondaryCta.to} className="btn btn-ghost btn-lg" data-testid="hero-about-btn">{HOME.secondaryCta.label}</Link>
          </div>
        </div>
      </section>

      {/* ── PRODUCTS ─────────────────────────────────────── */}
      <section className="section" style={{ borderTop: '1px solid var(--border)' }}>
        <div className="wrap">
          <div className="eyebrow reveal">{HOME.productsHeading}</div>
          <h2 className="reveal d1" style={{ marginBottom: '40px' }}>{HOME.productsHeading}</h2>
          <div className="grid-3">
            {products.map((product, i) => (
              <ProductCard key={product.id} product={product} delay={`d${i + 1}`} />
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </PageWrap>
  );
}
